/* Show each option's price - in red - inside the variant dropdown.

   A native <select> cannot colour part of an option: macOS draws system menus and ignores
   the styling entirely. So the real <select> stays in the page and keeps doing the work,
   and a styled list is drawn on top of it. Clicking a row writes the value back to the
   <select> and fires its change event, which is what Shopify's variant logic listens for.

   Only single-option products are enhanced (handles, door sizes). With two or more options
   a value has no price of its own, so those dropdowns are left exactly as they were. If
   this script never runs, the ordinary dropdown is still there and still works.
*/
(function () {
  /* Dawn rebuilds the picker from the server after every variant change. If that fragment
     ever comes back without data-d2f-price on its options, build() used to bail out and the
     shopper was left with the plain select - prices gone until a full page reload. The
     prices are therefore cached by variant id on first render and reused from then on. */
  var priceByValue = {};

  function priceOf(option) {
    if (option.dataset.d2fPrice) {
      priceByValue[option.value] = option.dataset.d2fPrice;
      return option.dataset.d2fPrice;
    }
    return priceByValue[option.value] || '';
  }

  function money(pennies) {
    return '£' + (pennies / 100).toFixed(2);
  }

  function build(select) {
    var options = Array.prototype.slice.call(select.options);
    if (!options.length) return;
    // seed/refresh the cache, then decide - a known price counts as much as a fresh one
    var haveAny = options.some(function (o) { return priceOf(o); });
    if (!haveAny) return;

    var wrap = document.createElement('div');
    wrap.className = 'd2f-vsel';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'd2f-vsel__button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');

    var list = document.createElement('div');
    list.className = 'd2f-vsel__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    function rowLabel(option) {
      var price = priceOf(option);
      var name = document.createElement('span');
      name.className = 'd2f-vsel__name';
      name.textContent = option.textContent.trim();
      var frag = document.createDocumentFragment();
      frag.appendChild(name);
      if (price) {
        var amount = document.createElement('span');
        amount.className = 'd2f-vsel__price d2f-price';
        amount.textContent = money(parseInt(price, 10));
        frag.appendChild(amount);
      }
      return frag;
    }

    function paintButton() {
      button.textContent = '';
      var current = select.options[select.selectedIndex];
      if (current) button.appendChild(rowLabel(current));
      if (window.d2fApplyVat) window.d2fApplyVat(wrap);
    }

    options.forEach(function (option, i) {
      var row = document.createElement('button');
      row.type = 'button';
      row.className = 'd2f-vsel__row';
      row.setAttribute('role', 'option');
      row.dataset.index = i;
      if (option.disabled) row.classList.add('is-unavailable');
      row.appendChild(rowLabel(option));
      row.addEventListener('click', function () {
        select.selectedIndex = i;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        close();
        paintButton();
      });
      list.appendChild(row);
    });

    function open() {
      list.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      if (window.d2fApplyVat) window.d2fApplyVat(list);
    }
    function close() {
      list.hidden = true;
      button.setAttribute('aria-expanded', 'false');
    }
    button.addEventListener('click', function () {
      list.hidden ? open() : close();
    });
    document.addEventListener('click', function (event) {
      if (!wrap.contains(event.target)) close();
    });
    button.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    // Sit OUTSIDE Dawn's .select wrapper, not inside it: nesting a bordered button in a
    // bordered wrapper drew a box within a box. The wrapper (and the real <select> inside
    // it) stays in the DOM, hidden, so Shopify's variant logic is untouched.
    var wrapper = select.closest('.select') || select.parentNode;
    wrap.d2fSelect = select;          // used to spot controls whose select has gone
    wrapper.classList.add('d2f-vsel__hidden');
    /* Exactly one control per picker. If Dawn swapped the select but left the surrounding
       block alone, the previous control is still sitting here and would stack a second
       dropdown on top of this one - so anything already in this container goes first. */
    Array.prototype.forEach.call(
      wrapper.parentNode.querySelectorAll('.d2f-vsel'),
      function (stale) { stale.remove(); }
    );
    wrapper.parentNode.insertBefore(wrap, wrapper);
    wrap.appendChild(button);
    wrap.appendChild(list);
    paintButton();
    select.addEventListener('change', paintButton);
  }

  function init(root) {
    (root || document).querySelectorAll('.product-form__input select, variant-selects select')
      .forEach(function (select) {
        if (select.dataset.d2fEnhanced) return;
        select.dataset.d2fEnhanced = '1';
        build(select);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Dawn rebuilds the picker from the server after every variant change, throwing this
     control away and putting the plain select back.

     The first version waited 60ms before re-applying. That lost a race: on some changes the
     rebuild landed in a gap and the shopper was left with a stale control PLUS a fully
     visible native select - which is the one they then clicked, and it has no prices in it.

     So: react on the animation frame instead of a timer (it runs before the browser paints,
     so there is no frame where the bare select is on screen), and clear away any control
     whose select has been removed, so a stale one can never sit next to a live select. */
  function cleanupOrphans() {
    document.querySelectorAll('.d2f-vsel').forEach(function (control) {
      if (!control.d2fSelect || !document.contains(control.d2fSelect)) control.remove();
    });
  }

  /* Scheduled two ways on purpose. The animation frame runs before the browser paints, so
     the bare select never appears on screen - but it is paused entirely while a tab is in
     the background, which would strand a shopper who switched away mid-change. The timer
     covers that case. Whichever fires first does the work and cancels the other. */
  var frame = null;
  var timer = null;
  function run() {
    if (frame) { cancelAnimationFrame(frame); frame = null; }
    if (timer) { clearTimeout(timer); timer = null; }
    cleanupOrphans();
    init();
    cleanupOrphans();   // a rebuild can strand the control it replaced
  }
  function refresh() {
    if (frame || timer) return;
    frame = requestAnimationFrame(run);
    timer = setTimeout(run, 120);
  }

  new MutationObserver(refresh).observe(document.body, { childList: true, subtree: true });

  // Dawn re-renders in response to the select's own change event; catching it here means the
  // refresh is already queued before the rebuild starts, rather than chasing it afterwards.
  document.addEventListener('change', function (event) {
    if (event.target && event.target.tagName === 'SELECT') refresh();
  }, true);
})();
